import { render, staticRenderFns } from "./save.vue?vue&type=template&id=70081633&scoped=true&"
import script from "./save.vue?vue&type=script&lang=js&"
export * from "./save.vue?vue&type=script&lang=js&"
import style0 from "./save.vue?vue&type=style&index=0&id=70081633&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70081633",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/site-front-pipline/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70081633')) {
      api.createRecord('70081633', component.options)
    } else {
      api.reload('70081633', component.options)
    }
    module.hot.accept("./save.vue?vue&type=template&id=70081633&scoped=true&", function () {
      api.rerender('70081633', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/workplace/components/save.vue"
export default component.exports